import script from "./DialogChatArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./DialogChatArea.vue?vue&type=script&lang=ts&setup=true"

import "./DialogChatArea.vue?vue&type=style&index=0&id=683090d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683090d4"]])

export default __exports__